export default __webpack_public_path__ + "static/sm-poster8-fe7bc0e4de7c043096461a021b39a470.png";